import { UserSubscriptionV2 } from '../../model/v2/EntitiesV2';
import dateService from '../../services/DateService';
import apiAxiosV2 from './CustomAxiosV2';

class UserSubscriptionApiV2 {
    listAll = async (): Promise<UserSubscriptionV2[]> => {
        const response = await apiAxiosV2.get<UserSubscriptionV2[]>(`/user-subscriptions`);
        response.data.forEach(this.loadDates);

        return response.data;
    };

    get = async (id: number): Promise<UserSubscriptionV2> => {
        const response = await apiAxiosV2.get<UserSubscriptionV2>(` /user-subscriptions/${id}`);
        this.loadDates(response.data);

        return response.data;
    };

    create = async (userSubscription: UserSubscriptionV2): Promise<UserSubscriptionV2> => {
        const response = await apiAxiosV2.post<UserSubscriptionV2>('/user-subscriptions', userSubscription);
        this.loadDates(response.data);

        return response.data;
    };

    update = async (userSubscription: UserSubscriptionV2): Promise<UserSubscriptionV2> => {
        const response = await apiAxiosV2.put<UserSubscriptionV2>(
            `/user-subscriptions/${userSubscription.id}`,
            userSubscription,
        );
        this.loadDates(response.data);

        return response.data;
    };

    /**
     * Loads the dates of a user subscription.
     * @param trap - the user subscription
     */
    private loadDates(userSubscription: UserSubscriptionV2) {
        userSubscription.subscriptionPaid = dateService.transformDate(userSubscription.subscriptionPaid);
        userSubscription.subscriptionExpired = dateService.transformDate(userSubscription.subscriptionExpired);
    }
}

const userSubscriptionApiV2: UserSubscriptionApiV2 = new UserSubscriptionApiV2();
export default userSubscriptionApiV2;
